var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.5348 13.2503L13.8061 12.5654L12.4363 14.0226L13.165 14.7075L14.5348 13.2503ZM15.3151 16.7286L16.0437 17.4135L17.4135 15.9563L16.6849 15.2714L15.3151 16.7286ZM13.165 14.7075L15.3151 16.7286L16.6849 15.2714L14.5348 13.2503L13.165 14.7075ZM7.80284 13.7423C4.60742 13.7423 2 11.1231 2 7.87114H0C0 12.2088 3.48406 15.7423 7.80284 15.7423V13.7423ZM13.6057 7.87114C13.6057 11.1231 10.9983 13.7423 7.80284 13.7423V15.7423C12.1216 15.7423 15.6057 12.2088 15.6057 7.87114H13.6057ZM7.80284 2C10.9983 2 13.6057 4.61916 13.6057 7.87114H15.6057C15.6057 3.53347 12.1216 0 7.80284 0V2ZM7.80284 0C3.48406 0 0 3.53347 0 7.87114H2C2 4.61916 4.60742 2 7.80284 2V0Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.12020a6c.svg";
export { ForwardRef as ReactComponent };